
import { defineComponent, ref } from 'vue'

export default defineComponent({
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },

  setup (props, context) {
    const isFold = ref(false)

    return {
      isFold,
    }
  }
})
